<script setup>
import Booking from "lib/booking/components/Booking";
import { addSrvSchema } from "lib/modules/schema";

const props = defineProps(["now", "srv"]);

const url = new URL(document.location);
const sp = url.searchParams;

const params = {
	...sp.has("method") && { method: sp.get("method") },
	...sp.has("branch_id") && { branch_id: sp.get("branch_id") === "null" ? null : sp.get("branch_id") },
	...sp.has("lang_id") && { lang_id: sp.get("lang_id") },
	...sp.has("user_id") && { user_id: sp.get("user_id") },
	...sp.has("start") && { start: parseInt(sp.get("start")) }
};

const pack = sp.get("pack") === "1";

function updateUrl(state) {
	const prms = ["method", "branch_id", "lang_id", "user_id", "start"];

	for (const prm of prms) {
		if (prm in state)
			sp.set(prm, state[prm]);
		else
			sp.delete(prm);
	}

	history.replaceState(null, "", url.toString());
}

addSrvSchema({
	...props.srv,
	rating: props.srv.org.rating,
	rating_cnt: props.srv.org.rating_cnt,
	org_name: props.srv.org.name
});
</script>

<template>
	<div class="service card-16 grid gap-16">
		<UiExpandable class="vui-prewrap" line-clamp="10">{{ srv.descr }}</UiExpandable>
		<div class="separator"></div>
		<div class="grid cols-2">
			<div v-if="srv.pack && !pack" class="duration">{{ $pgettext("minutes x quantity", "%1 min x %2", Math.round(srv.duration / 60), srv.pack + 1) }}</div>
			<div v-else class="duration">{{ $pgettext("minutes", "%1 min", Math.round(srv.duration / 60)) }}</div>
			<div class="price justify-self-end">{{ srv.price !== null ? $lcurrency(pack ? 0 : srv.price, srv.ccy_id) : $gettext("Free") }}</div>
		</div>
		<div v-if="pack" class="vui-hint">{{ $gettext("Schedule new session from your package.") }}</div>
		<div v-else-if="srv.pack > 0" class="vui-hint">
			<template v-if="srv.price !== null">{{ $gettext("The amount includes all sessions in the package.") }}</template>
			{{ $gettext("Schedule the first session now and the remaining sessions later.") }}
		</div>
	</div>
	<Booking
		:srv-id="srv.srv_id"
		:ccy-id="srv.ccy_id"
		:tracking="!srv.org.demo"
		:now="now"
		:params="params"
		:pack="pack"
		@state-change="updateUrl"
	/>
</template>
